import { ArrowRight, RefreshCw } from "lucide-react";

/**
 * FxConversionMock — focuses ONLY on the multi-currency conversion
 * panel (no sidebar, no other widgets). iter-211.2 — replaced the
 * full-screen /accounts screenshot per user feedback ("solo la parte
 * de la conversión").
 *
 * Default data is developer-flavoured (Stripe USD payout converted
 * to COP, mirror of a real /for/developer story).
 */
export function FxConversionMock({
  fromAmount = "4.500",
  fromCurrency = "USD",
  toAmount = "18.670.500",
  toCurrency = "COP",
  rate = "4.149,00",
  source = "BCRP · 17:42 UTC",
  payer = "Stripe payout · Vercel SaaS Consulting",
}) {
  return (
    <div
      className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden"
      data-testid="mock-fx-conversion"
    >
      <div className="px-5 pt-5 pb-3 flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-emerald-700">
            Cobro internacional
          </div>
          <div className="font-display text-sm font-semibold text-slate-900 mt-0.5">
            {payer}
          </div>
        </div>
        <div className="flex items-center gap-1 text-[10px] font-medium text-slate-500">
          <RefreshCw className="h-3 w-3" />
          {source}
        </div>
      </div>

      <div className="px-5 pb-5">
        <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
          {/* Source amount */}
          <div className="rounded-xl bg-slate-50 border border-slate-200 px-3 py-3 text-center">
            <div className="text-[10px] uppercase tracking-wider font-semibold text-slate-500">
              Original
            </div>
            <div
              className="font-display text-2xl font-bold text-slate-900 tabular-nums leading-tight mt-1"
              data-testid="fx-mock-from-amount"
            >
              {fromAmount}
            </div>
            <div className="text-[11px] font-bold text-emerald-700 mt-0.5">
              {fromCurrency}
            </div>
          </div>

          {/* Arrow */}
          <div className="flex flex-col items-center text-emerald-600">
            <ArrowRight className="h-4 w-4" />
            <div className="text-[9px] uppercase tracking-wider font-bold text-emerald-700 mt-0.5">
              @ {rate}
            </div>
          </div>

          {/* Target amount */}
          <div className="rounded-xl bg-emerald-50 border border-emerald-200 px-3 py-3 text-center">
            <div className="text-[10px] uppercase tracking-wider font-semibold text-emerald-700">
              En tu moneda
            </div>
            <div
              className="font-display text-2xl font-bold text-emerald-800 tabular-nums leading-tight mt-1"
              data-testid="fx-mock-to-amount"
            >
              {toAmount}
            </div>
            <div className="text-[11px] font-bold text-emerald-700 mt-0.5">
              {toCurrency}
            </div>
          </div>
        </div>

        <p className="text-[11px] text-slate-500 leading-snug mt-3">
          Lumfi convirtió automáticamente al tipo de cambio del día. Tu MRR,
          balance y proyecciones quedan en la moneda de tu perfil.
        </p>
      </div>
    </div>
  );
}
